import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import {
  PrimaryButton,
  TextButton,
  OutlinedButton,
} from '@prisjakt/ui/button/variants';

export const Form = styled.form``;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${layout.measurements.spacing150};
  margin-top: ${layout.measurements.spacing150};
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  border-top: 1px solid ${p => p.theme.lines.primary};
  padding: ${layout.measurements.spacing050} 0;
  background: ${p => p.theme.bg.primary};
  z-index: 10;
`;

export const SubmitButton = styled(PrimaryButton)`
  width: 33%;

  ${media.mediumDown`
    width: 50%;
  `};
`;

export const CancelButton = styled(TextButton)`
  margin-right: ${layout.measurements.spacing150};
`;

export const DeleteButton = styled(OutlinedButton)`
  margin-right: auto;
`;
